import { mapActions } from 'vuex'
import { CategoryParent, StoreStatus } from '@/constants'
import { sorts } from './partials/fields'

export default {
    template: '<router-view />',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setParams({
                sorter: vm.$policy('store').create ? sorts[1].value : sorts[0].value,
                status: vm.$policy('store').create ? '' : StoreStatus.ACTIVE,
            })
            // vm.fetchStores()
            vm.categories()
            vm.fetchTags()
        })
    },

    beforeRouteLeave (to, from, next) {
        this.resetParams()
        next()
    },

    methods: {
        ...mapActions({
            // fetchStores: 'store/fetch',
            setParams: 'store/setParams',
            resetParams: 'store/resetParams',
            fetchCategories: 'category/fetch',
            fetchTags: 'store/fetchTags'
        }),
        categories() {
            this.fetchCategories({
                no_paginate: true,
                parent: {
                    slug: CategoryParent.STORE_PARENT
                }
            })
        },
    }
}